class GoogleMapApi {
  constructor(el) {
    this.dom = {el: el}

    // this.apikey = 'AIzaSyBmwWPrzyM0rhZob8n_MWHRZBKZtYmpSz0'; // development
    // this.apikey = 'AIzaSyAThZmNY1GiYMsU2GhinttBeeOi03eIWrc'; // development2
    this.apikey = 'AIzaSyB8DpWSAOXy5lsm85UcRjASvvo5UH7lgJQ'; // production

    this.lat = '35.707661';
    this.lng = '139.7939329';
    this.siteName = 'sake-barhotel';
    this.marker = null;
    this.myOptions = null;
    this.markerOptions = null;

    // スタイルのカスタマイズ
    this.styleOptions = [
      {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
          {
            "saturation": "-100"
          }
        ]
      },
      {
        "featureType": "administrative.province",
        "elementType": "all",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
          {
            "saturation": -100
          },
          {
            "lightness": 65
          },
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
          {
            "saturation": -100
          },
          {
            "lightness": "50"
          },
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
          {
            "saturation": "-100"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "all",
        "stylers": [
          {
            "lightness": "30"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [
          {
            "lightness": "40"
          }
        ]
      },
      {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
          {
            "saturation": -100
          },
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "hue": "#ffff00"
          },
          {
            "lightness": -25
          },
          {
            "saturation": -97
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
          {
            "lightness": -25
          },
          {
            "saturation": -100
          }
        ]
      }
    ];

    this.init();
  }

  init() {
    const _this = this;

    window.initMap = function() {
      let latlng = new google.maps.LatLng(_this.lat, _this.lng);
      _this.myOptions = {
        zoom: 15, // 拡大比率
        center: latlng, // 表示枠内の中心点
        mapTypeControlOptions: { // 表示タイプの指定
          mapTypeIds: ['noText', google.maps.MapTypeId.ROADMAP]
        }
      };

      let map = new google.maps.Map(_this.dom.el, _this.myOptions);
      _this.markerOptions = {
        position: latlng,
        map: map,
        // icon: {
        //   anchor: new google.maps.Point(_this.pinX, _this.pinY),
        //   scaledSize: new google.maps.Size(_this.pinW, _this.pinH),
        //   size: new google.maps.Size( _this.pinW, _this.pinH ),
        //   url: pin_path
        // }
      };
  
      let styledMapOptions = {name: _this.siteName};
      let gmstyleType = new google.maps.StyledMapType(_this.styleOptions, styledMapOptions);
      map.mapTypes.set(_this.siteName, gmstyleType);
      map.setMapTypeId(_this.siteName);
      
      _this.marker = new google.maps.Marker(_this.markerOptions);
    }
      
    window.onload = function() {
      let script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?libraries=places,visualization&key=${_this.apikey}&v=weekly&callback=initMap`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    };
  }
}

export default GoogleMapApi